<script setup lang="ts">
import { ref } from "vue";
import { useRoute } from "vue-router";
import TableFilter from "./TableFilter.vue";

const searchInput = ref(useRoute().query.q as string);

defineProps({
  placeholder: {
    type: String,
    default: "Pesquisar",
  },
});

const emit = defineEmits(["search"]);

const onSearch = () => {
  emit("search", searchInput.value);
};

const handleInput = (event: any) => {
  if (!event.target.value) emit("search", "");
};
</script>

<template>
  <div class="card-header">
    <div class="row align-items-center">
      <div class="col">
        <div
          class="input-group input-group-flush input-group-merge input-group-reverse"
        >
          <input
            id="table_search_input"
            class="form-control list-search mt-1"
            type="search"
            v-model="searchInput"
            :placeholder="placeholder"
            @keyup.enter="onSearch"
            @input="handleInput"
          />
          <span class="input-group-text">
            <i class="fa-solid fa-search text-muted"></i>
          </span>
        </div>
      </div>

      <div class="col-auto pe-0" v-if="$slots.filter">
        <TableFilter>
          <slot name="filter"></slot>
        </TableFilter>
      </div>

      <div class="col-auto">
        <Button
          @onClick="onSearch"
          label="Pesquisar"
          class="btn-sm"
          outline
          id="table_search_button"
        />
      </div>
    </div>
  </div>
</template>
